import React, { useState, useEffect, useContext, useRef } from 'react';
import './css/header.css';
import './css/topbar.css';
import contact from '../../data/layouts/contact';
import { Link, useNavigate } from 'react-router-dom';
import { Store } from '../../Store';
import ModalLogin from '../screens/login/ModalLogin';
import ChangePassword from '../screens/login/ChangePassword';
import useIsDevice from '../../format/useIsDevice';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getError } from '../../utils';
import truncateWords from '../../format/truncateWords';

const Header = ({ navigationMenu }) => {
  const navigate = useNavigate();

  const { dispatch: ctxDispatch } = useContext(Store);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubMenu, setIsSubMenu] = useState(null);

  const isDevice = useIsDevice(0, 992);
  const ref = useRef();
  const { state } = useContext(Store);
  const { userInfo } = state;

  const [isVisible, setIsVisible] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [showChangePass, setChangePass] = useState(false);

  const userDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        userDropdownRef.current &&
        !userDropdownRef.current.contains(event.target)
      ) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const logoutHandler = async (e) => {
    e.preventDefault();
    try {
      await axios.get('/logout', {
        headers: { Authorization: `Bearer ${userInfo.token}` },
      });
      ctxDispatch({ type: 'USER_SIGNOUT' });
      localStorage.removeItem('userInfo');
      toast.success('Đăng xuất thành công');
    } catch (err) {
      localStorage.removeItem('userInfo');
      toast.error(getError(err));
    }
  };

  useEffect(() => {
    const el = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('show-slide');
          observer.unobserve(el);
        }
      },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => observer.disconnect();
  }, [ctxDispatch]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 0) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsSubMenu(null);
  };

  const toggleSubMenu = (idx) => {
    setIsSubMenu(isSubMenu === idx ? null : idx);
  };

  const navigatePage = (url) => {
    setIsSubMenu(null);
    navigate(url);
    setIsMenuOpen(false);
  };

  const saveBreadcrumb = (title1, url1, title2, url2) => {
    const breadcrumb = [
      {
        title: title1,
        slug: url1,
      },
      {
        title: title2,
        slug: url2,
      },
    ];
    ctxDispatch({
      type: 'SET_BREADCRUMB',
      payload: breadcrumb,
    });
    localStorage.setItem('resentBread', JSON.stringify(breadcrumb));
    navigate(url2 ? url2 : url1);
  };

  return (
    <div>
      <header
        className={`d-flex header-transition ${
          isVisible ? 'header-fixed' : ''
        } `}
      >
        <div className="container navbar-area d-flex align-items-center">
          <nav className="navbar navbar-expand-lg">
            <Link to="/" title={contact.name}>
              <img
                src={contact.logo}
                alt={contact.name}
                className="logo_main"
                loading="lazy"
              />
            </Link>

            <div className="mobile_menu_open d-flex align-items-center ">
              <div className="icon-user">
                {userInfo ? (
                  <div className="d-flex align-items-center text-black account mb-sm-0 mb-2">
                    <div
                      className="user-dropdown"
                      ref={userDropdownRef}
                      tabIndex={0}
                      onClick={() => setShowMenu((prev) => !prev)}
                    >
                      <span
                        style={{
                          border: '1px solid',
                          borderRadius: '100%',
                          padding: '2px 6px',
                          marginRight: '6px',
                          marginTop: '4px',
                        }}
                      >
                        <i className="fa-solid fa-user " />
                      </span>

                      {showMenu && (
                        <ul className="user-info p-0">
                          <li>
                            <div className="menu-title">
                              <h6 style={{ color: 'var(--color-primary)' }}>
                                Hội cựu sinh viên
                              </h6>
                              <p className="text-secondary">
                                {userInfo.userInformation?.roles?.[0]?.name ||
                                  'Chưa xác định'}
                              </p>
                            </div>
                          </li>
                          <li>
                            <div
                              className="menu-item"
                              onClick={() => setShowInfo(true)}
                            >
                              <p>Thông tin cá nhân</p>
                              <i className="fa-regular fa-id-card" />
                            </div>
                          </li>
                          <li>
                            <div
                              className="menu-item"
                              onClick={() => setChangePass(true)}
                            >
                              <p>Đổi mật khẩu</p>
                              <i className="fa-solid fa-key" />
                            </div>
                          </li>
                          <li onClick={logoutHandler}>
                            <div className="menu-item log-out">
                              <p>Đăng xuất</p>
                              <i className="fa-solid fa-arrow-right-from-bracket" />
                            </div>
                          </li>
                        </ul>
                      )}
                    </div>
                    <ChangePassword
                      show={showChangePass}
                      onHide={() => setChangePass(false)}
                    />
                    <ModalLogin
                      show={showInfo}
                      onHide={() => setShowInfo(false)}
                      isUserInfo
                    />
                  </div>
                ) : (
                  <div className="d-flex align-items-center account mb-sm-0 mb-2">
                    <div
                      className="user-dropdown"
                      onClick={() => setModalShow(true)}
                    >
                      <span className="btn-topbar-login user-name">
                        <img
                          src="/images/icons/account.png"
                          alt=""
                          className="icon mx-1"
                        />
                        Đăng nhập
                      </span>
                    </div>
                    <ModalLogin
                      show={modalShow}
                      onHide={() => setModalShow(false)}
                    />
                  </div>
                )}
              </div>
              <div onClick={toggleMenu}>
                <img
                  src="/images/icons/icons8-menu-50.png"
                  alt="menu icon"
                  loading="lazy"
                />
              </div>
            </div>

            <div
              className={`collapse navbar-collapse sub-menu-bar justify-content-end ${
                isMenuOpen ? 'show' : ''
              }`}
            >
              <ul id="nav" className="navbar-nav ms-auto ps-0">
                {navigationMenu.slice(1, 8).map((data, index) => (
                  <li key={data.id} className="nav-item position-relative">
                    <div
                      className="link-nav"
                      onClick={() =>
                        saveBreadcrumb(data.title, data.url, '', '')
                      }
                    >
                      <span className="d-block">
                        {data.title}
                        {data.children.length > 0 && (
                          <i
                            className="fas fa-chevron-down"
                            style={{ fontSize: '11px', paddingLeft: '5px' }}
                          ></i>
                        )}
                      </span>
                    </div>
                    <ul className="subnav position-absolute ps-0">
                      {data.children.map((item, itemIndex) => (
                        <li key={item.id}>
                          <div
                            className="link-subnav"
                            title={item.title}
                            onClick={() =>
                              saveBreadcrumb(
                                data.title,
                                data.url,
                                item.title,
                                item.url
                              )
                            }
                          >
                            {item.title}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
              <span
                onClick={() =>
                  document
                    .getElementById('enrollment')
                    ?.scrollIntoView({ behavior: 'smooth' })
                }
                className="mx-2 btn ms-auto go-to-enrollment-form"
              >
                Liên hệ với chúng tôi
              </span>

              {userInfo ? (
                <div className="d-flex align-items-center text-black account mb-sm-0 mb-2">
                  <div
                    className="user-dropdown"
                    ref={userDropdownRef}
                    tabIndex={0}
                    onClick={() => setShowMenu((prev) => !prev)}
                  >
                    <span className="user-name">
                      Xin chào,{' '}
                      {truncateWords(
                        userInfo.userInformation?.full_name,
                        isDevice ? 5 : 2
                      )}{' '}
                      <i className="fas fa-sort-down p-1" />
                    </span>

                    {showMenu && (
                      <ul className="user-info p-0">
                        <li>
                          <div className="menu-title">
                            <h6 style={{ color: 'var(--color-primary)' }}>
                              Hội cựu sinh viên
                            </h6>
                            <p className="text-secondary">
                              {userInfo.userInformation?.roles?.[0]?.name ||
                                'Chưa xác định'}
                            </p>
                          </div>
                        </li>
                        <li>
                          <div
                            className="menu-item"
                            onClick={() => setShowInfo(true)}
                          >
                            <p>Thông tin cá nhân</p>
                            <i className="fa-regular fa-id-card" />
                          </div>
                        </li>
                        <li>
                          <div
                            className="menu-item"
                            onClick={() => setChangePass(true)}
                          >
                            <p>Đổi mật khẩu</p>
                            <i className="fa-solid fa-key" />
                          </div>
                        </li>
                        <li onClick={logoutHandler}>
                          <div className="menu-item log-out">
                            <p>Đăng xuất</p>
                            <i className="fa-solid fa-arrow-right-from-bracket" />
                          </div>
                        </li>
                      </ul>
                    )}
                  </div>
                  <ChangePassword
                    show={showChangePass}
                    onHide={() => setChangePass(false)}
                  />
                  <ModalLogin
                    show={showInfo}
                    onHide={() => setShowInfo(false)}
                    isUserInfo
                  />
                </div>
              ) : (
                <div className="d-flex align-items-center account mb-sm-0 mb-2">
                  <div
                    className="user-dropdown"
                    onClick={() => setModalShow(true)}
                  >
                    <span className="btn-topbar-login user-name">
                      <img
                        src="/images/icons/account.png"
                        alt=""
                        className="icon mx-1"
                      />
                      Đăng nhập
                    </span>
                  </div>
                  <ModalLogin
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                  />
                </div>
              )}
            </div>
          </nav>
        </div>
      </header>
      <div
        className={`mobile_menu_overlay ${isMenuOpen ? 'show' : ''}`}
        onClick={toggleMenu}
      ></div>
      <div
        className={`mobile_menu_wrapper ${
          isMenuOpen ? 'show_mobile_menu_wrapper' : ''
        }`}
      >
        <div className="d-flex justify-content-between align-items-center pe-2">
          <img
            src={contact.logo}
            alt={contact.name}
            className="logo-side-bar"
          />
          <span className="icon-close" onClick={toggleMenu}>
            ×
          </span>
        </div>
        <nav className="mobile_menu_nav mobile-menu">
          <ul>
            {navigationMenu.slice(1, navigationMenu.length - 1).map(
              (data, index) =>
                data.status === 'active' && (
                  <React.Fragment key={data.id || index}>
                    <li key={data.id} className="position-relative">
                      <div
                        className={`dropdown-btn ${
                          isSubMenu === index ? 'active' : ''
                        }`}
                        onClick={() => toggleSubMenu(index)}
                      >
                        <span onClick={() => navigatePage(data.url)}>
                          {data.title}
                        </span>
                        {data.children.length > 0 && (
                          <i
                            className={`icon-angle-down ${
                              isSubMenu === index ? 'rotate-up' : ''
                            }`}
                          ></i>
                        )}
                      </div>
                    </li>
                    <ul
                      className={`dropdown-container ${
                        isSubMenu === index ? 'show' : ''
                      }`}
                    >
                      {data.children.map((item, itemIndex) => (
                        <li key={item.id}>
                          <div
                            className="link-nav-mobile"
                            title={item.title}
                            onClick={() => navigatePage(item.url)}
                          >
                            {item.title}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </React.Fragment>
                )
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Header;
